import { useState } from "react";
import AppDialog from "../../../components/Common/AppDialog";
import ImportantNotice from "../../../components/Common/ImportantNotice";
import Label from "../../../components/Common/Label";
import Helpers from "../../../helpers/helpers";

export default function MarkReserved({ open, close, handleSubmit, windowWidth, isBulkAction = false, selectedItems = [] }) {
    const [showAll, setShowAll] = useState(false);
    const itemsToShow = isBulkAction ? showAll ? selectedItems : selectedItems.slice(0, 2) : [];
    return (
        <AppDialog
            title={'Mark as reserved'}
            open={open}
            close={close}
            positiveTitle={'Mark as Reserved'}
            positivePress={() => handleSubmit()}
            cancelButton={true}
            width={'40%'}
            isMobile={windowWidth <= 768}
        >
            {
                isBulkAction ?
                    <>
                        <div>Are you sure you want to mark selected {selectedItems.length} advert(s) as reserved?</div>
                        <ol style={{ paddingInline: 20, paddingBlock: 10 }}>
                            {itemsToShow?.map((item, idx) => (
                                <li key={idx} className="mb-2 ">
                                    <div className="d-flex align-items-center">
                                        {item?.make?.name || '-'} {item?.model?.model_name || ''}
                                        <Label.GeneralStatusLabel label={item?.status || '-'} list={Helpers.advertStatus} marginLeft={"10px"} />
                                    </div>
                                </li>
                            ))}
                            {selectedItems.length > 2 && (
                                <div
                                    onClick={() => setShowAll(!showAll)}
                                    className="clickable underline"
                                    style={{ marginTop: '10px' }}
                                >
                                    {showAll ? 'Show less' : 'Show more'}
                                </div>
                            )}
                        </ol>
                    </> :
                    <>
                        <div>Are you sure you want to mark this advert as reserved?</div>
                    </>
            }

            <div className="my-2">
                <ImportantNotice
                    iconName={'solar:lightbulb-linear'}
                    iconColor={'#1D1B1B'}
                    backgroundColor={'#F0F0F0'}
                    color={'#1D1B1B'}
                    message={'Marking this advert as Reserved will temporarily hide it from public search results and prevent new enquiries. Existing enquiries will remain unaffected. You can change the status back to Active anytime.'}
                />
            </div>
        </AppDialog>
    )
}